export default {
  init(context) {
    context.state.socket.on('connect', () => {
      context.dispatch('fetchPersons');
    });

    // Register API events
    context.state.socket.on('add-person', (data) => {
      if (context.state.personCollection === data.collection) {
        context.commit('addPerson', { person: data.person });
      }
    });
    context.state.socket.on('update-person', (data) => {
      if (context.state.personCollection === data.collection) {
        context.commit('updatePerson', { person: data.person });
      }
    });
    context.state.socket.on('delete-person', (data) => {
      if (context.state.personCollection === data.collection) {
        context.commit('deletePerson', { id: data.id });
      }
    });
  },
  logError(context, err) {
    console.error(`API error: ${err}`);
  },
  fetchPersons(context) {
    context.state.socket.emit(
      'fetch-persons',
      {
        collection: context.state.personCollection,
      },
      (err, persons) => {
        if (err) {
          context.dispatch('logError', err);
          return;
        }
        context.commit('setPersons', { persons });
      }
    );
  },
  addPerson(context, { person }) {
    context.state.socket.emit(
      'add-person',
      {
        collection: context.state.personCollection,
        person,
      },
      (err, newPerson) => {
        if (err) {
          context.dispatch('logError', err);
          return;
        }
        context.commit('addPerson', { person: newPerson });
      }
    );
  },
  updatePerson(context, { person }) {
    context.state.socket.emit(
      'update-person',
      {
        collection: context.state.personCollection,
        person,
      },
      (err, updatedPerson) => {
        if (err) {
          context.dispatch('logError', err);
          return;
        }
        context.commit('updatePerson', { person: updatedPerson });
      }
    );
  },
  deletePerson(context, { person }) {
    context.state.socket.emit(
      'delete-person',
      {
        collection: context.state.personCollection,
        id: person.id,
        imgFileName: person.imgFileName,
      },
      (err) => {
        if (err) {
          context.dispatch('logError', err);
          return;
        }
        context.commit('deletePerson', { id: person.id });
      }
    );
  },
};
